import type React from 'react';
import { Fragment } from 'react';

import { useScrollToNode } from '@UI/mainScreen/scrollToNode/useScrollToNode';
import { Modal } from '@kathondvla/react-shared-components/src/components';
import { setMode } from '@newStore/documentUI/documentUIState';
import {
  selectContentNodesWithExtraProperties,
  selectPatchesToCleanNodes,
} from '@newStore/documentUI/nodeTypeConfigSelectors';
import { labelForConfigPropertyMap } from '@nodeTypeConfig/labelForConfigPropertyMap';
import { patchNodeAction } from '@store/actions/documentActions';
import { set } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';

const ExtraFieldsModal: React.FC<{
  onClose?: () => void;
}> = ({ onClose = () => {} }) => {
  const nodesWithExtraProperties = useSelector(selectContentNodesWithExtraProperties);
  const cleanUpPatches = useSelector(selectPatchesToCleanNodes);

  const dispatch = useDispatch();

  const onConfirm = () => {
    dispatch(setMode('EDIT'));
    cleanUpPatches.forEach((patch) => {
      dispatch(patchNodeAction(patch.key, set({}, patch.property, null)));
    });
    onClose();
  };
  const scrollToItem = useScrollToNode();

  return (
    <>
      <Modal.Header title="Extra velden" onClose={onClose} />
      <Modal.Body>
        <div>
          <p>
            Voor de volgende elementen werden ingevulde velden gevonden die niet (langer) relevant
            zijn.
          </p>
          <ul>
            {nodesWithExtraProperties.map(
              ({ item, extraDefinedProperties, parentHref, typeSingle }) => {
                const title = (
                  <>
                    <strong>{typeSingle}</strong>
                    {': '}
                    {item.title || item.description || item.$$html}
                  </>
                );
                return (
                  <li key={`${item.key}`}>
                    {parentHref ? (
                      <a
                        onClick={() => {
                          scrollToItem(item.$$meta.permalink, parentHref);
                        }}
                      >
                        {title}
                      </a>
                    ) : (
                      <span>{title}</span>
                    )}
                    <dl style={{ marginLeft: '1em' }}>
                      {extraDefinedProperties.map((property) => (
                        <Fragment key={item.key + property}>
                          <dt>{labelForConfigPropertyMap.get(property) || property}:</dt>
                          <dd>
                            {typeof item[property] === 'object'
                              ? JSON.stringify(item[property])
                              : item[property]}
                          </dd>
                        </Fragment>
                      ))}
                    </dl>
                  </li>
                );
              },
            )}
          </ul>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-link pull-left" onClick={onClose}>
          Annuleren
        </button>
        <button className="btn btn-primary" onClick={onConfirm}>
          Data wissen
        </button>
      </Modal.Footer>
    </>
  );
};

ExtraFieldsModal.displayName = 'displayName';

export default ExtraFieldsModal;
